import { type ShortfallFix, ShortfallFix_Type } from "../../generated/core/v1/shortfall";
import { formatMonth } from "../lib/dates";
import { money } from "../lib/format";

/** Words for the engine's shortfall fixes (FindShortfallFixes). Never "bankruptcy". */
export function fixTitle(f: ShortfallFix): string {
  switch (f.type) {
    case ShortfallFix_Type.EXTRA_MONTHLY_INCOME:
      return `${money(f.amount)} a month more income, starting ${f.startDate ? formatMonth(f.startDate) : "now"}`;
    case ShortfallFix_Type.MONTHLY_EXPENSE_CUT:
      return `Spending ${money(f.amount)} a month less, starting ${f.startDate ? formatMonth(f.startDate) : "now"}`;
    case ShortfallFix_Type.LUMP_SUM_TODAY:
      return `Putting ${money(f.amount)} into chequing now`;
    default:
      return `A change of ${money(f.amount)}`;
  }
}

export function fixDetail(f: ShortfallFix): string {
  switch (f.type) {
    case ShortfallFix_Type.EXTRA_MONTHLY_INCOME:
      return `Before tax, every month${f.endDate ? ` until ${formatMonth(f.endDate)}` : ""}: a raise, a side income or more hours. The earlier it starts, the smaller it needs to be.`;
    case ShortfallFix_Type.MONTHLY_EXPENSE_CUT:
      return "Lifestyle spending first, then essentials. Eating out, subscriptions and travel are where most households find it.";
    case ShortfallFix_Type.LUMP_SUM_TODAY:
      return "A one-off amount set aside today, for example from a bonus, a tax refund or savings you hold elsewhere.";
    default:
      return "";
  }
}
